module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_vm._v("CHAPTER 1")]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("LET ME FILL YOU IN")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Okay, here’s the deal—")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "270",
      "src": "images/1D_fmt.jpeg",
      "width": "412"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Beginning with an apology is probably not the best way to start this book, but I think it’s the smart thing to do. That way when you get to the part where I messed up, I can just remind you I already said I’m sorry and you might give me a break.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Before I tell you what I’m sorry about, it might be wise to fill you in on a few other things. If you’re new to my journals and drawings, you probably don’t know my name. Well, it’s … ")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "260",
      "src": "images/1E_fmt.jpeg",
      "width": "351"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My mom is the only one who calls me by my full name, and that’s only when she’s really ticked off. The rest of the time she calls me Ribert. Most people call me Rob. I’m a student at Softrock Middle School in a town called Temon. Our school’s a little behind the times. According to my principal we just barely got our own Facebook page.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "290",
      "src": "images/1F_fmt.jpeg",
      "width": "511"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Principal Smelt’s a pretty good principal. He plays the pan flute and is in a two-man band named Leftover Angst. Still, I’m not adding my school as a friend on Facebook. I just don’t want anyone to see how boring my page is or that my only friend at the moment is my father.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "400",
      "src": "images/1G_fmt.jpeg",
      "width": "484"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I have a pretty normal family. Of course you couldn’t tell that from our last family photo. The photographer arranged us in an awkward way, and my little brother, Tuffin, kept lifting his shirt. So now it looks like Libby is showing the world her stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/1H_fmt.jpeg",
      "width": "173"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s my favorite family picture ever. My older sister hates it, but Libby hates a lot of things. The only thing she truly likes is herself. And if you ask her what she’s into she always answers …")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "210",
      "src": "images/1I_fmt.jpeg",
      "width": "397"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Tuffin’s not really into himself, he’s more into mischief. Lately he’s been slipping strange things into the sandwiches I bring to school for lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "250",
      "src": "images/1J_fmt.jpeg",
      "width": "480"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My mom tells me to be thankful for the cute things that Tuffin does.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "250",
      "src": "images/1K_fmt.jpeg",
      "width": "326"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I like Tuffin, but it’s hard to feel thankful after biting into a peanut butter and rubber band sandwich. I guess my mom has to say things like that though. She’s a mom—a mom who spends a lot of her time taking naps on the couch. She’s almost always wearing her robe, and she claims that having children makes her tired. That’s probably true, but how much effort does it take to give me orders while I’m trying to sneak away to hang out with my friends?")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "260",
      "src": "images/1L_fmt.jpeg",
      "width": "599"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My dad doesn’t ever nap—he’s too busy doing a million things to have the time to lie down. He’s always excited about life. He has glasses, and he wears a suit and tie because, as he puts it,")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/1M_fmt.jpeg",
      "width": "363"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My dad owns a small company that sells playground equipment to schools. His first name is Earl, and he loves his job.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "250",
      "src": "images/1N_fmt.jpeg",
      "width": "499"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Sometimes he uses me and my friends to test things. Three days ago he had us try out a big swing called an Exer-Glide. It was an unusual swing that looks like a metal cage. It’s supposed to hold one person, and you pump with your arms, not your legs.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "350",
      "src": "images/1O_fmt.jpeg",
      "width": "535"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My dad claimed it was an extra-safe swing because kids couldn’t jump out and hurt themselves. Well, maybe it was hard to jump out, but it didn’t seem very safe. My friends and I had a difficult time getting it to move.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "350",
      "src": "images/1P_fmt.jpeg",
      "width": "425"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My dad had a really tough time pulling all of us out. If you ask me, though, I think it was just as tough having to listen to his lecture about us … ")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "125",
      "src": "images/1Q_fmt.jpeg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I should at least mention Janae. It might be important for you to know who she is. Janae lives next door, and I like her way more than she likes me. I can barely walk right when she’s around. Yesterday I saw her in the hall at school and tried to wave. While waving, I tripped over a small kid getting stuff from his bottom locker and fell flat on my nose.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "300",
      "src": "images/1R_fmt.jpeg",
      "width": "602"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I actually tried to stay home from school this morning because my nose was so swollen, but my mom didn’t let me. So I guess she’s partly to blame. If I hadn’t gone to school today, I wouldn’t have made the mistake I’ve already apologized for. Sadly, going back in time is not yet an option.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "350",
      "src": "images/1S_fmt.jpeg",
      "width": "630"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229e5985","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 69
// module chunks = 0